module.exports = __webpack_public_path__ + "79d21fef9d806b19fadf656cfe20d867.svg";